"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { rem } from "polished";
import makeStyles from "../../theming/make-styles.js";
import Button from "../button/index.js";
const sizes = {
    small: rem(32),
    medium: rem(40),
    large: rem(48),
};
const useStyles = makeStyles()((theme, { active, color, round, size, variant }) => {
    const palette = theme.palette(color).pagination;
    return {
        item: Object.assign({ "minWidth": sizes[size], "height": sizes[size], "padding": 0, "border": `${theme.size(1)} solid`, "borderColor": palette.borderColor, "borderRadius": round ? "100%" : undefined, "&:disabled": {
                color: palette.disabled.color,
                backgroundColor: palette.disabled.backgroundColor,
                borderColor: palette.disabled.borderColor,
            } }, (variant === "outline"
            ? {
                "color": palette.outline.color,
                "backgroundColor": palette.outline.backgroundColor,
                "borderColor": active ? palette.outline.activeItem.borderColor : palette.outline.borderColor,
                "&:hover:not(:disabled)": {
                    color: palette.outline.hover.color,
                    backgroundColor: palette.outline.hover.backgroundColor,
                    borderColor: active ? palette.outline.hover.activeItem.borderColor : palette.outline.hover.borderColor,
                },
                "&:focus:not(:disabled)": {
                    "&:hover:not(:disabled)": {
                        backgroundColor: palette.outline.hover.backgroundColor,
                    },
                },
                "&:active:not(:disabled)": {
                    color: palette.outline.active.color,
                    backgroundColor: palette.outline.active.backgroundColor,
                    borderColor: palette.outline.active.borderColor,
                },
            }
            : {})),
    };
});
export const PaginationItem = React.forwardRef(function PaginationItem(_a, ref) {
    var { active = false, children, className, color = "primary", round = true, size = "medium", variant = "link" } = _a, props = __rest(_a, ["active", "children", "className", "color", "round", "size", "variant"]);
    const { classes, cx } = useStyles({
        active,
        color: active ? color : "text",
        round,
        size,
        variant,
    });
    return (_jsx(Button, Object.assign({ ref: ref, className: cx(classes.item, className), color: active ? color : "text", shadow: false, variant: active ? "filled" : variant }, props, { children: children })));
});
export default PaginationItem;
//# sourceMappingURL=pagination-item.js.map